import api from '@/api/nextstep'
import { isEmptyObject, ToBoolean, encode18bit } from 'utils'

const EmapflowNextStep = {
  data() {
    return {
      cur_node_info: {}, // cur_node_info(当前节点信息，区别当前选择节点cur_node)
      labels: {
        cur_node: this.$LocalH5('nextStep.currentNode'),
        cur_node_desc: this.$LocalH5('nextStep.cur_node_desc'),
        node: this.$LocalH5('nextStep.nextStep'),
        node_desc: this.$LocalH5('nextStep.node_desc'),
        assignee: this.$LocalH5('nextStep.assignee'),
        addAssignee: this.$LocalH5('nextStep.addAssignee'),// pc、移动端均使用
        assigneeGroup: this.$LocalH5('nextStep.assigneeGroup'),
        circulator: this.$LocalH5('nextStep.circulator')
      },
      isFinishedTask: false, // 标识流程业务是否为已办结
      node: null,
      cur_node: {},  // cur_node(当前选中节点)对象格式｛ "isEndNode": "1", "nodeId": xxx, "documentation": xxx ｝
      node_list: [],
      assignees: [],
      assigneesAdd: [], //添加办理人选中的人 --- pc、移动端均使用
      assignee_list: [],
      errorMsg: {
        node: this.$LocalH5('nextStep.nodeMsg'),
        assignee: this.$LocalH5('nextStep.assigneeMsg')
      },
      circulators: [],
      circulator_list: [],
      asyncAssignee: false, // 用来标识获取处理人api是否成功,true为成功
      formdataClone: this.submitformdata,
      circulatorSelectFalg: true,
      isMultiInstance:false,
      addAssigneeHidden:true
    }
  },
  props: {
    value: {},
    defId: String,
    defKey: String,
    taskId: String,
    showNextNode: {
      type: Boolean,
      default: false
    },
    showNextAssignees: {
      type: Boolean,
      default: true
    },
    allowAddAssignee: { // 可添加处理人，从所有人员中选择处理人并在提交时添加到下一步办理人
      type: Boolean,
      default: false
    },
    //添加下一个办理人---针对移动端
    showAddNextAssignees: {
      type: Boolean,
      default: false
    },
    submitformdata: Object,
    multiple: { // 自定义默认选人模式开启时，是否开启多选
      type: Boolean,
      default: true
    },
    autoSelect: { // 下一步处理人在2-10之间时是否自动勾选填涂
      type: Boolean,
      default: false
    },
    defaultCustom: { // 无处理人时，是否开启默认自定义选人模式,即从全部组织架构中选
      type: Boolean,
      default: true
    },
    onnodeverify: Function,
    assigneeurl: String,
    echostyle: {  // 回显样式：姓名(name)、姓名+工号(id)、姓名+部门(dept)、姓名+工号+部门(whole)、树形结构（tree）
      type: String,
      default: 'name'
    },
    hasCirculate: Boolean,
    schema: {
      type: String,
      default: 'default'  // default、simple，其中simple为简洁模式，即仅存在下一步节点，下一步选人, 传阅保持有效
    },
    nodeurl: String,
    nodelabel: String,
    assigneeslabel: String
  },
  watch: {
    submitformdata: {
      handler: function(newVal) {
        this.formdataClone = newVal;
      },
      deep: true
    }
  },
  computed: {
    visible() {
      return !this.isFinishedTask && (this.showNextNode || this.showNextAssignees || this.showAddNextAssignees)
    },
    nextstepObj() {
      let nextAssigneesArr = Object.prototype.toString.call(this.assignees) === '[object Array]' ? this.assignees : this.assignees.split(',')
      let assigneeAddArr = Object.prototype.toString.call(this.assigneesAdd) === '[object Array]' ? this.assigneesAdd : this.assigneesAdd.split(',')
      let nextAssigneesAll = Array.from(new Set(JSON.parse(JSON.stringify(nextAssigneesArr)).concat(JSON.parse(JSON.stringify(assigneeAddArr)))))

      if(this.hasCirculate) {
        return {
          nextNodeId: this.cur_node.nodeId,
          nextAssignees: nextAssigneesAll.join(','),
          circulatedUsers: Object.prototype.toString.call(this.circulators) === '[object Array]' ? this.circulators.join(',') : this.circulators,
          assigneeAdd: assigneeAddArr.join(',')
        }
      } else {
        return {
          nextNodeId: this.cur_node.nodeId,
          nextAssignees: nextAssigneesAll.join(','),
          assigneeAdd: assigneeAddArr.join(',')
        }
      }
      
    }
  },
  methods: {
    emitInput() {
      this.$emit('input', this.nextstepObj)
    },
    /**
     * @method getCurNodeInfo
     * @description 获取当前节点信息
     * @param {Array} nextNodes -- 节点数据信息
     */
    getCurNodeInfo() {
      const _this = this;
      api.getCurNode({
        "taskId": this.taskId,
        "defKey": this.defKey
      }).then(data => {
        if(data && data.currentNodes) {
          _this.cur_node_info =  data.currentNodes
        }
      })

    },
    getCirculators() {
      const _this = this;
      api.getCirculors({
        "taskId": this.taskId,
        "defKey": this.defKey,
        "formData": JSON.stringify(this.formdataClone)
      }).then(data => {
        if(data && data.items) {
          _this.circulator_list = data.items.circulatedUsers || [];
          if(_this.circulator_list.length) {
            _this.circulator_list = _this.setEchoStyle(this.circulator_list);
            if(_this.circulator_list.length <= 10) {
              let ids = [], names =[];
              _this.circulator_list.forEach(item => {
                ids.push(item.userId);
                names.push(item.display)
              })
              _this.circulators = ids;
              _this.circulator_display = names.join(',');
            }
          } else {
            _this.circulatorSelectFalg = false
          }
        } else {
          _this.circulatorSelectFalg = false
        }
      })
    },
    /**
     * @method processingNodes
     * @description 节点信息数据处理
     * @param {Array} nextNodes -- 节点数据信息
     * @param {Object} formdata -- 表单信息
     */
    processingNodes(nextNodes) {
      if(Object.prototype.toString.call(nextNodes) !== '[object Array]') return
      if(nextNodes.length === 1) {
        this.node = nextNodes[0].nodeId;
        this.cur_node = nextNodes[0];
        this.node = nextNodes[0].nodeId;
        this.node_display = nextNodes[0].nodeName;
        if(this.cur_node.isEndNode !== '1' && this.showNextAssignees) {
          this.getAssignees()
        }
        this.emitInput()
      } else {
        this.node = "";
        this.cur_node = {};
      }
    },

    /**
     * @method getNextNodes
     * @description 获取下一步节点信息
     * @param {Object} formdata -- 表单信息
     * rerurn Promise 返回一个promise对象
     */
    getNextNodes(formdata, callback) {
      formdata = formdata ? JSON.stringify(formdata) : JSON.stringify(this.formdataClone)
      // this.formdataClone = JSON.parse(formdata || '{}')
      try {
        this.formdataClone = formdata ? JSON.parse(formdata) : this.formdataClone;
      } catch (e) {
        // this.formdataClone = this.formdataClone;
      }
      const _this = this;
      api.getNodes(this.nodeurl, {
        "taskId": this.taskId,
        "defKey": this.defKey,
        "formData": formdata
      }).then(data => {
        if(_this.schema === 'default') {
          // 历史问题兼容
          if(data && data.nextNodes && Object.prototype.toString.call(data.nextNodes) === '[object Array]') {        
            _this.node_list = Object.assign([], data.nextNodes);
            // 节点接口数据干预
            if(_this.onnodeverify !== undefined && typeof _this.onnodeverify === 'function') _this.node_list = _this.onnodeverify(_this.node_list);
          }
        } else {
          if(_this.loading !== undefined) _this.loading = false;
          if(_this.onnodeverify !== undefined && typeof _this.onnodeverify === 'function') {
            _this.node_list = _this.onnodeverify(data);
            if(Object.prototype.toString.call(_this.node_list) !== '[object Array]') {
              _this.node_list = [];
              console.error("onnodeverify 方法返回值类型要求为数组类型");
            }
          }
        }
        _this.processingNodes(_this.node_list);
        callback && callback();
        let isUpdate = formdata ? true : false;
        _this.$emit("node_complete", data, isUpdate);
      })
    },

    /**
     * @method processingAssignees
     * @description 下一步处理人数据处理
     * @param {Object} items -- 处理人数据信息
     */
    processingAssignees(items) {
      let keys = Object.keys(items)
      if(keys.includes("candidateGroups")) {
        this.assignee_list = items.candidateGroups.map(opt => {
          opt.userId = "group(" + opt.groupId + ")"
          opt.display = opt.groupName
          return opt
        })
        this.isMultiInstance = true
        return
      }

      let assignee = items.assignee; // 对应流程设计器处理人--某一个人
      if(assignee && !isEmptyObject(assignee)) {
        this.assignee_list = [assignee];
        this.assignees = [assignee.userId];
        this.assignee_display = assignee.userName;
      } else { 
        let users = [];
        for(var key in items){
          if(key !== 'assignee') users = users.concat(items[key]);
        }

        users = this.uniq(users);

        this.assignee_list = users;
        // 判断是否只有一个人，自动显示
        if(users.length == 1) {
          this.assignee_list = users;
          this.assignees = [users[0].userId];
          this.assignee_display = users[0].userName;
        } else {
          // 多选且自动补全，修改为少于等于10人时全部展示 提出人：刘志鹏，确认人：王志伟 2020/7/13
          if(this.multiple && this.autoSelect && users.length > 1 && users.length <= 10) {
            let userNames = [];
            this.assignees = [];
            const _this = this;
            users.forEach(user => {
              if(user.userId) {
                userNames.push(user.userName);
                _this.assignees.push(user.userId);
              }
            });
            this.assignee_display = userNames.join(",");
          } else {
            this.assignees =  [];
            this.assignee_display = '';
          }
        }
      }
      this.assignee_list = this.setEchoStyle(this.assignee_list);
      this.emitInput();
    },

    /**
     * @method getAssignees
     * @description 获取下一步办理人信息
     * rerurn Promise 返回一个promise对象
     */
    getAssignees(formdata, callback) {
      this.isMultiInstance = false
      if(!this.cur_node.nodeId) {
        this.toastMsg(this.$LocalH5('nextStep.nodeEmptyMsg'));
        return
      }
      this.asyncAssignee = true;
      formdata = formdata ? JSON.stringify(formdata) : JSON.stringify(this.formdataClone)
      try {
        this.formdataClone = formdata ? JSON.parse(formdata) : this.formdataClone;
      } catch (e) {
        // this.formdataClone = this.formdataClone;
      }
      api.getAssignees( this.assigneeurl, {
        defId: this.defId,
        taskId: this.taskId,
        defKey: this.defKey,
        oneLegKicking: ToBoolean(this.cur_node.oneLegKicking),
        nodeId: this.cur_node.nodeId,
        formData: formdata
      }).then(data => { // Post
         this.asyncAssignee = false;
        if(data && data.items) {
          if(data.items.assignee){
            // 当下一步环节配置了分配人则添加办理人不显示
            this.addAssigneeHidden = true
          }else{
            this.addAssigneeHidden = false
          }
          this.processingAssignees(data.items)
        }
        callback && callback();
        let isUpdate = !!formdata;
        this.$emit("assignee_complete", data, isUpdate); 
      })
    },
    /**
     *  数组去重、去空对象
     *  @param {Array} arr
     *  return {Array} tempObj
     */
    uniq(arr) {
      let tempId = [], tempObj = [];
      arr.forEach(function(obj) {
        // 过滤可能存在的空对象
        if(!isEmptyObject(obj) && tempId.indexOf(obj.userId) === -1) {
          tempId.push(obj.userId);
          tempObj.push(obj);
        }
      });
      return tempObj;
    },
    /**
     *  回显样式设置
     *  @param {Array} arr
     *  return {Array} tempObj
     */
    setEchoStyle(arr, keys) {
      const _this = this;
      if(!keys) {
        keys = {
          userId: "userId",
          userName: "userName",
          deptName: "deptName"
        }
      }
      if(!arr) return
      return arr.map(obj => {
        if(!obj[keys.userName]) {
          obj.display = obj.encodeId || encode18bit(obj[keys.userId]);
        } else {
          if(_this.echostyle == "name") {
            obj.display = obj[keys.userName]
          } else if(_this.echostyle == "id") {
            obj.display = obj[keys.userName] + '(' + (obj.encodeId || encode18bit(obj[keys.userId])) + ')';
          } else if (_this.echostyle == "dept") {
            obj.display = obj[keys.deptName] ? (obj[keys.userName] + '(' + obj[keys.deptName] + ')') : obj[keys.userName];
          } else if (_this.echostyle == "whole") {
            obj.display = obj[keys.deptName] ? (obj[keys.userName] + '(' + (obj.encodeId || encode18bit(obj[keys.userId])) + '-' + obj[keys.deptName] + ')') 
            : (obj[keys.userName] + '(' + (obj.encodeId || encode18bit(obj[keys.userId])) + ')')
          } else {
            obj.display = obj[keys.userName] + '(' + (obj.encodeId || encode18bit(obj[keys.userId])) + ')';
          }
        }
        return obj
      })
    },
    validateDefault() {
      let result = { valid: true };
      if(this.showNextNode && !this.nextstepObj.nextNodeId) {
        result = {
          key: 'node',
          msg: this.errorMsg.node,
          valid: false
        }
        return result;
      }
      if(this.schema === 'default') {
        if(this.cur_node.isEndNode === '0' && this.showNextAssignees && (!this.nextstepObj.nextAssignees || this.nextstepObj.nextAssignees.length === 0)) {
          result = {
            key: 'assignee',
            msg: this.errorMsg.assignee,
            valid: false
          }
          return result;
        }
      } else {
        if(this.showNextAssignees && (!this.nextstepObj.nextAssignees || this.nextstepObj.nextAssignees.length === 0)) {
          result = {
            key: 'assignee',
            msg: this.errorMsg.assignee,
            valid: false
          }
          return result;
        }
      }
      return result;
    }
  },
  created() {
    // 获取传阅人
    if(this.hasCirculate) {
      this.getCirculators();
    }
    // 如果下一步节点，办理人都不存在，则停止所有请求
    if(!(this.showNextNode || this.showNextAssignees)) return;

    // taskId为 空字符串，标识当前为启动状态，根据这一特点，可以确定不是最后一个节点；如果[isFinishedTask = true],隐藏下一步组件
    if(this.taskId) {
      api.getFlowParams({
        "taskId": this.taskId,
        "defKey": this.defKey
      }).then(data => {
        if(data && data.items) {
          this.isFinishedTask = data.items.isFinishedTask;
          if(!this.isFinishedTask) this.getNextNodes();
        }
      })
    }else{
      this.getNextNodes()
    }
    // 获取当前节点描述
    if(this.schema != 'simple') {
      this.getCurNodeInfo();
    }  
  }
}

export default EmapflowNextStep